"use client";
import "./index.scss";
import { useState } from "react";
import { displayValue, StatusComponent } from "../OtherBetsDropdown";
import "../OtherBetsDropdown/index.scss";
import ICON_ARROW_DOWN_MOBILE_BLACK from "@/assets/images/Arrow_drop_down.svg";

// Sắp xếp lại odds theo đội nhà thắng , hòa , đội khách thắng
const formatCorrectScoresOdds = (correctScoresOdds) => {
  if (!Array.isArray(correctScoresOdds) || !correctScoresOdds.length) {
    return { home: [], draw: [], away: [] };
  }

  return correctScoresOdds.reduce(
    (acc, curr) => {
      if (Number(curr.homeScore) > Number(curr.awayScore)) {
        acc.home.push(curr);
      } else if (Number(curr.homeScore) < Number(curr.awayScore)) {
        acc.away.push(curr);
      } else {
        acc.draw.push(curr);
      }
      return acc;
    },
    { home: [], draw: [], away: [] }
  );
};

// Có data không ?
const isContainData = (data) => {
  return (
    data &&
    (data?.home?.length > 0 || data?.draw?.length > 0 || data?.away?.length > 0)
  );
};

const CorrectScoresOdds = ({ correctScoresOdds }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const formatedCorrectScoresOdds = formatCorrectScoresOdds(correctScoresOdds);

  return (
    <div className="correct-scores-odds-container">
      <div className="bg-[var(--theme-bg)] flex justify-between items-center @max-sm:h-5 @max-sm:w-full @max-sm:rounded-t-sm @max-sm:px-3 @lg:h-[2rem] @lg:mb-1 @lg:py-1 @lg:rounded-md">
        <div
          className="flex flex-wrap items-center gap-1 hover:cursor-pointer"
          onClick={() => handleCollapse()}
        >
          <>
            <img
              alt="Net88"
              src={ICON_ARROW_DOWN_MOBILE_BLACK}
              width={20}
              height={20}
              className={`w-6 h-6 transition-transform duration-300 ${isCollapsed ? "rotate-180" : ""}`}
            />
          </>
          <span className="font-semibold text-sm text-[var(--theme-text)] w-[7.75rem]">
            Tổng tỷ số
          </span>
        </div>
      </div>
      <div
        id="collapse"
        className={`bg-white rounded-br-lg rounded-bl-lg  ${
          isCollapsed ? "hidden" : "visible"
        }`}
      >
        <div className="max-h-[250px] overflow-auto">
          {isContainData(formatedCorrectScoresOdds) && (
            <>
              <div className="correct-scores-odds-header">
                {formatedCorrectScoresOdds?.home && (
                  <div className="text-xxs">Tỉ Số Thắng Đội Nhà</div>
                )}
                {formatedCorrectScoresOdds?.draw && (
                  <div className="text-xxs">Tỉ Số Hòa</div>
                )}
                {formatedCorrectScoresOdds?.away && (
                  <div className="text-xxs">Tỉ Số Thắng Đội Khách</div>
                )}
              </div>
              <div className="correct-scores-odds-body">
                {formatedCorrectScoresOdds?.home && (
                  <div className="correct-scores-odds-body-row">
                    {formatedCorrectScoresOdds?.home?.map((item, index) => (
                      <div
                        key={index}
                        className="correct-scores-odds-body-item"
                      >
                        <span className="score">
                          {` ${item?.homeScore} - ${item?.awayScore}`}
                        </span>
                        <span className="odds">
                          {displayValue(item?.odds)}
                          <StatusComponent trend={item?.initialOddsTrend} />
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {formatedCorrectScoresOdds?.draw && (
                  <div className="correct-scores-odds-body-row">
                    {formatedCorrectScoresOdds?.draw?.map((item, index) => (
                      <div
                        key={index}
                        className="correct-scores-odds-body-item"
                      >
                        <span className="score">
                          {` ${item?.homeScore} - ${item?.awayScore}`}
                        </span>
                        <span className="odds">
                          {displayValue(item?.odds)}
                          <StatusComponent trend={item?.initialOddsTrend} />
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {formatedCorrectScoresOdds?.away && (
                  <div className="correct-scores-odds-body-row">
                    {formatedCorrectScoresOdds?.away?.map((item, index) => (
                      <div
                        key={index}
                        className="correct-scores-odds-body-item"
                      >
                        <span className="score">
                          {` ${item?.homeScore} - ${item?.awayScore}`}
                        </span>
                        <span className="odds">
                          {displayValue(item?.odds)}
                          <StatusComponent trend={item?.initialOddsTrend} />
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CorrectScoresOdds;